const ActivitySpecialEventEnum = Object.freeze({
    PROPOSAL_CLIENT_ACCEPT: 'PROPOSAL_CLIENT_ACCEPT',
    PROPOSAL_ADVISER_ACCEPT: 'PROPOSAL_ADVISER_ACCEPT',
    PROPOSAL_MULTI_PRODUCT_SPLIT: 'PROPOSAL_MULTI_PRODUCT_SPLIT',
    PROPOSAL_APPLICATION_SIGNED: 'PROPOSAL_APPLICATION_SIGNED',
    PROPOSAL_FUNDS_TRANSFERRED: 'PROPOSAL_FUNDS_TRANSFERRED'
});

export default ActivitySpecialEventEnum;
